module.exports = __webpack_public_path__ + "img/egg.ea937578.png";